import React from 'react'
import NewsSummary from './news-summary'
import styled from 'styled-components'
import { inheritPrimaryColor } from '../colors'
import { useScrollReset } from '../scroll'

const preloadedNews = typeof window !== 'undefined' && window.__data__ && window.__data__.news

const NewsSummaries = styled(({ data, ...props }) => {
  useScrollReset()
  const news = data ? data.news[1] : preloadedNews[1]

  if (!news) return null
  return (
    <div {...props}>
      <div css='max-width: 1140px; flex-grow: 1; display: flex; flex-direction: column;'>
        {news.map(newsItem => <>
          <div css='display: flex; justify-content: center;'>
            <NewsSummary css='margin: 20px 0px;' maxHeight='250px' key={newsItem.slug} date={newsItem.date} slug={newsItem.slug} title={newsItem.title.rendered} />
          </div>
          <div css={`height: 1px; background-color: ${inheritPrimaryColor}`} />
        </>)}
      </div>
    </div>
  )
})`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0px 20px 60px;
  min-height: 500px;
`

export default NewsSummaries